import React from 'react'
import PropTypes from 'prop-types'
import { ContactListItem } from './CustomerAccessories'

class ContactList extends React.PureComponent {

  static propTypes = {
    selectedCustomer: PropTypes.shape(),
    contacts: PropTypes.array,
    onSelection: PropTypes.func
  }

  constructor(props){
    super(props)

    this.state = {
      results: [],
      selectedCustomer: props.selectedCustomer
    }
  }

  componentWillMount(){
    if (this.props.contacts){
      this.prepare(this.props.contacts)
    }
  }

  componentWillReceiveProps(nextProps){
    if (this.props.contacts !== nextProps.contacts){
      this.prepare(nextProps.contacts)
    }
  }

  prepare = (contacts) => {
    const results = []
    contacts.forEach(contact => {
      results.push (
        <ContactListItem
          key={contact.id}
          id={contact.id}
          contactItem={contact}
          onContactSelected={this.onContactSelected}/>
      )
    })
    this.setState({ results })
  }

  onContactSelected = (selectedContact) => {
    if (selectedContact){
      this.setState({ selectedContact })
    }
    this.props.onSelection(selectedContact)
  }

  render(){
    if (this.state.results.length === 0){
      return null
    }
    return (<div> { this.state.results } </div>)
  }

}

export default ContactList



// WEBPACK FOOTER //
// ./src/customer/ContactList.js